import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, Send } from 'lucide-react';
import { Button } from './ui/button';

export const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
  { name: 'Whitepaper', path: '/whitepaper' },
  { name: 'Earn', path: '/how-to-earn' },
  { name: 'Chart', path: '/chart' },
  { name: 'Blog', path: '/blog' }];


  return (
    <>
      {/* Skip to content link for accessibility */}
      <a
        href="#main-content"
        className="sr-only focus:not-sr-only focus:absolute focus:top-4 focus:left-4 focus:z-50 focus:px-4 focus:py-2 focus:bg-gold focus:text-black focus:font-bold focus:rounded"
      >
        Skip to main content
      </a>
      
      <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
    isScrolled ? 'bg-black/90 backdrop-blur-lg border-b border-gold/20' : 'bg-transparent'}`
    }>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center space-x-3 group mr-8 md:mr-12" aria-label="FLUMBERICO Home - Return to homepage">
            <div className="w-12 h-12 rounded-full bg-gradient-to-br from-gold via-silver to-gold p-0.5">
              <div className="w-full h-full rounded-full bg-black flex items-center justify-center">
                <span className="text-2xl font-bold text-gold">$F</span>
              </div>
            </div>
            <span className="text-2xl font-black text-gold tracking-tight group-hover:text-silver transition-colors">
              FLUMBERICO
            </span>
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8 lg:space-x-10">
            {navLinks.map((link) =>
            <Link
              key={link.path}
              to={link.path}
              className={`text-base lg:text-lg font-bold transition-colors hover:text-gold tracking-wide ${
              location.pathname === link.path ? 'text-gold' : 'text-silver'}`
              }>

                {link.name}
              </Link>
            )}
            <a
              href="https://t.me/flumberico"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-2 text-base lg:text-lg font-bold text-silver hover:text-gold transition-colors"
              aria-label="Join FLUMBERICO official Telegram channel">
              <Send size={20} aria-hidden="true" />
              <span>Telegram</span>
            </a>
            <a
              href="https://pump.fun/coin/Hu8PvhDSyVwNUYnXsWQ12DEX2baydRximcbaSAkKpump"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Buy FLUMBERICO tokens on Pump.fun">

              <Button className="inline-flex items-center justify-center whitespace-nowrap transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0 h-9 hover:bg-gold/90 lg:px-8 lg:py-3 lg:text-lg !font-bold !text-base gap-2 px-6 py-2.5 rounded-md shadow text-black !bg-[#FFFFFF]">
                Buy Now
              </Button>
            </a>
          </nav>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="md:hidden p-2 text-gold hover:text-silver transition-colors"
            aria-label={isMobileMenuOpen ? "Close navigation menu" : "Open navigation menu"}
            aria-expanded={isMobileMenuOpen}>

            {isMobileMenuOpen ? <X size={28} aria-hidden="true" /> : <Menu size={28} aria-hidden="true" />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen &&
      <div className="md:hidden bg-black/95 backdrop-blur-lg border-t border-gold/20">
          <nav className="px-4 py-6 space-y-4">
            {navLinks.map((link) =>
          <Link
            key={link.path}
            to={link.path}
            onClick={() => setIsMobileMenuOpen(false)}
            className={`block text-lg font-semibold transition-colors ${
            location.pathname === link.path ? 'text-gold' : 'text-silver hover:text-gold'}`
            }>

                {link.name}
              </Link>
          )}
            <a
            href="https://t.me/flumberico"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-2 text-lg font-semibold text-silver hover:text-gold transition-colors"
            aria-label="Join FLUMBERICO official Telegram channel">
              <Send size={20} aria-hidden="true" />
              <span>Join Telegram</span>
            </a>
            <a
            href="https://pump.fun/coin/Hu8PvhDSyVwNUYnXsWQ12DEX2baydRximcbaSAkKpump"
            target="_blank"
            rel="noopener noreferrer"
            className="block"
            aria-label="Buy FLUMBERICO tokens on Pump.fun">

              <Button className="w-full bg-gold hover:bg-gold/90 text-black font-bold">
                Buy Now
              </Button>
            </a>
          </nav>
        </div>
      }
    </header>
    </>
  );

};